import { api } from "@/lib/api/client";
import type { Paginated, Report, ReportSeverity, ReportStatus } from "./types";

type ListParams = {
  facility: number;
  status?: ReportStatus;
  severity?: ReportSeverity;
};

function qs(params: ListParams): string {
  const sp = new URLSearchParams();
  sp.set("facility", String(params.facility));
  if (params.status) sp.set("status", params.status);
  if (params.severity) sp.set("severity", params.severity);
  return sp.toString();
}

export const reportsApi = {
  list: (params: ListParams) =>
    api.get<Paginated<Report>>(`/api/reports/?${qs(params)}`),
  get: (id: number) => api.get<Report>(`/api/reports/${id}/`),

  acknowledge: (id: number) => api.post<Report>(`/api/reports/${id}/acknowledge/`),
  start: (id: number) => api.post<Report>(`/api/reports/${id}/start/`),
  resolve: (id: number) => api.post<Report>(`/api/reports/${id}/resolve/`),
  dismiss: (id: number) => api.post<Report>(`/api/reports/${id}/dismiss/`),
  markDuplicate: (id: number, duplicateOf: number) =>
    api.post<Report>(`/api/reports/${id}/mark_duplicate/`, {
      duplicate_of: duplicateOf,
    }),

  comment: (id: number, text: string) =>
    api.post<{ detail: string }>(`/api/reports/${id}/comments/`, { text }),
};
